<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        @onClick="abrirForm"
      />
      <div v-if="formOpen">
        <insumoForm
          ref="insumoform"
          :insumo="insumo"
          :salvar="salvar"
          :set-loading="setLoading"
         
        />
      </div>
      <div v-else>
        <div class="col-md-8 d-flex">
          <b-form-group
            id="input-group-1"
            label="Pesquisar Por Codigo"
            label-for="filter"
          >
            <b-input-group>
              <b-form-input
                id="filter"
                v-model="searchInsumo"
                type="text"
                placeholder="INSUMO..."
                @keydown.enter.prevent="searchInsumo && searchInsumo.length >= 1 ? searchForCode() : listaInsumo(0)"
              ></b-form-input>
              <b-input-group-append
                v-if="searchInsumo && searchInsumo.length >= 1"
              >
                <b-button @click="searchForCode">Pesquisar Código</b-button>
              </b-input-group-append>
              <b-input-group-append v-else>
                <b-button @click="listaInsumo(0)">Buscar Todos</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <Table
          id="table"
          :form-open="formOpen"
          :tables-fields="grupoFields"
          :table-items="insumos"
          :count-rows="rows"
          :page="0"
          @onDelete="onDelete"
          @onEdit="edit"
          @onPaginate="listaInsumo"
        >
          <template v-slot:cell(qrcode)="row">
            <img :src="row.item.qrcode" />
          </template>
        </Table>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import insumoForm from '../../../../components/forms/controleObra/insumoForm.vue'
import Table from '@/src/components/tables/table-register.vue'
import insumoService from '../../../../services/serviceInsumoObra'
import alertMixin from '@/src/mixins/alertMixin'

export default {
  components: { Layout, HeaderPage, insumoForm, Table },
  mixins: [alertMixin],
  data() {
    return {
      isLoading: false,
      pageTitles: {
        title: 'Insumos',
        subtitle: '',
      },
      formOpen: false,
      searchInsumo: '',
      grupoFields: [
        {
          key: 'qrcode',
          label: 'QrCode',
          class: 'size-col-20',
        },
        {
          key: 'codigo',
          label: 'Código ',
          class: 'size-col-20',
        },
        {
          key: 'descricao',
          label: 'Descrição',
          class: 'size-col-20',
        },
        {
          key: 'unidade',
          label: 'Unidade',
          class: 'size-col-20',
        },
        {
          key: 'estoqueBaixo',
          label: 'Estoque mínimo',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      excelColumns: [
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Quantidade',
          field: 'qtde',
        },
        {
          label: 'Estoque mínimo',
          field: 'estoqueBaixo',
        },
        {
          label: 'Alerta de Estoque',
          field: 'alertaEstoque',
        },
      ],
      excelList: [],
      insumo: {},
      insumos: [],
      rows: 0,
      numeros: '',
     
    }
  },
  mounted() {
    this.listaInsumo(0)
  },
  methods: {
    updateByFiliais(){
      this.listaInsumo(0)
      this.$refs.insumoform.updateByFiliais();
      
    },
    setLoading(loading) {
      this.isLoading = loading
    },
    abrirForm() {
      this.formOpen = !this.formOpen
      this.pageTitles.subtitle = 'Cadastre o insumo na filial selecionada'
      this.insumo = {}
      if (!this.formOpen) {
        this.listaInsumo(0)
      }
    },
    justNumber(e) {
      this.numeros = e.target.value.replace(/[^0-9]/g, '')
      this.searchInsumo = this.numeros
    },
    async salvar() {
      try {
        this.isLoading = true
        if (this.insumo._id) {
          await insumoService.update(this.insumo._id, this.insumo)
          this.insumo = {}
          this.abrirForm()
          this.isLoading = false
          this.successMessage('Atualizado com sucesso')
        }     
        if(!this.insumo._id && this.$store.state.filial) {
        
          this.insumo.filial= this.$store.state.filial
          console.log(this.insumo)
          await insumoService.create(this.insumo)
          this.insumo = {}
          this.abrirForm()
          this.isLoading = false
          this.successMessage('Salvo com sucesso')
        }else{
           this.isLoading = false
            this.errorMessage('Selecione a Filial')
        }
      } catch (error) {
        this.isLoading = false
        this.errorMessage('Erro ao salvar')
      }
    },

    async listaInsumo(currentPage) {
      this.pageTitles.subtitle = 'Visualize aqui os insumos cadastrados'
      this.isLoading = true
      try {
        let {
          data: { data },
        } = await insumoService.listByPage(currentPage, this.$store.state.filter, this.$store.state.filial )
        this.insumos = data.results
        this.rows = data.count
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.errorMessage('erro ao listar')
      }
    },

    async onDelete(id) {
      try {
        this.isLoading = true
        await insumoService.remove(id)
        this.successMessage('Deletado com sucesso')
        this.isLoading = false
        this.listaInsumo(0)
      } catch (error) {
        this.isLoading = false
        this.errorMessage('Erro ao deletar')
      }
    },
    edit(item) {
      this.abrirForm()
      this.insumo = item
    },
    async searchForCode() {
      let resultado = await insumoService.buscaCodigo(this.searchInsumo,undefined, this.$store.state.filter, this.$store.state.filial )
      this.insumos = [resultado.data.data]
      if (this.insumos[0] === null || this.insumos[0] === undefined ) {
        this.errorMessage('Nenhum Insumo encontrado')
      }
      // console.log(resultado.data.data)
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
